import React from 'react'

import { Tab } from 'components'
import { useTabs } from 'hooks'
import { TabsProvider } from 'hooks/useTabs/provider'


import GerenciamentoSeguranca from './components/GerenciamentoSeguranca'
import Search from './components/Search'
import { SearchByContractProvider } from './context'

const SearchByContractComponent: React.FC = () => {
  const {
    tabs,
    handleChangeTab,
    selectedTab
  } = useTabs(['Pesquisar'])

  return (
    <>
      <Tab tabs={tabs} value={selectedTab.position} handleChange={handleChangeTab} />
      {selectedTab.position === 0 && <Search />}
      {selectedTab.position === 1 && <GerenciamentoSeguranca />}
    </>
  )
}

const SearchByContract: React.FC = () => {
  return (
    <TabsProvider>
      <SearchByContractProvider>
        <SearchByContractComponent />
      </SearchByContractProvider>
    </TabsProvider>
  )
}
export default SearchByContract
